const ProductLoanActionTypes = {
	/*************** ADD PRODUCT LOAN PROPOSAL START ***************/
	ADD_PRODUCT_LOAN_PROPOSAL_START: 'add_product_loan_proposal_start',
	ADD_PRODUCT_LOAN_PROPOSAL_SUCCESS: 'add_product_loan_proposal_success',
	ADD_PRODUCT_LOAN_PROPOSAL_FAILURE: 'add_product_loan_proposal_failure',
	ADD_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET: 'add_product_loan_proposal_response_reset',
	ADD_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED: 'add_product_loan_proposal_response_changed',

	/*************** UPDATE PRODUCT LOAN PROPOSAL START ***************/
	UPDATE_PRODUCT_LOAN_PROPOSAL_START: 'update_product_loan_proposal_start',
	UPDATE_PRODUCT_LOAN_PROPOSAL_SUCCESS: 'update_product_loan_proposal_success',
	UPDATE_PRODUCT_LOAN_PROPOSAL_FAILURE: 'update_product_loan_proposal_failure',
	UPDATE_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET: 'update_product_loan_proposal_response_reset',
	UPDATE_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED: 'update_product_loan_proposal_response_changed',
	/*************** UPDATE PRODUCT LOAN PROPOSAL END ***************/
};
export default ProductLoanActionTypes;
